import { ArchiveSettingsIcon } from './ArchiveSettingsIcon';

/**
 * author: Colton Wiscombe
 * id 1F72C97E-9F21-4096-B59B-CD23519B1367
 * name archive-settings
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-settings.svg
 * tags
 * - Settings 
 */
export const BoxSettingsIcon = ArchiveSettingsIcon;
export default BoxSettingsIcon